import { render, staticRenderFns } from "./AuthorizedPickupListDetailsReport.vue?vue&type=template&id=63840a92&scoped=true"
import script from "./AuthorizedPickupListDetailsReport.vue?vue&type=script&lang=js"
export * from "./AuthorizedPickupListDetailsReport.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedPickupListDetailsReport.vue?vue&type=style&index=0&id=63840a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63840a92",
  null
  
)

export default component.exports